var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-space',{attrs:{"direction":"vertical","size":1}},[_c('vue-qrcode',{staticClass:"receipt-card--qr-code",attrs:{"value":_vm.code}}),_vm._v(" "),_c('span',{staticClass:"trawl-text-bolder",style:(_vm.textStyle)},[_vm._v(" No Resi: "+_vm._s(_vm.code)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }